var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.noNeedFlag)?_c('c-form',{ref:"cForm",staticClass:"bg-white border-8 attachment-info-form",attrs:{"model":_vm.formData,"render-data":_vm.renderData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }